module.exports = __webpack_public_path__ + "img/mail_outline_black_24dp.31c75f0d.svg";